<template>
  <div class="messageArea" v-loading="loading">
    <div class="m-operation">
      <div class="m-o-switch">
        <span class="m-o-s-text" @click.stop="changeShowBrief(!showBrief)"
          >显示模块简介</span
        >
        <el-switch
          v-model="showBrief"
          active-color="#3681FC"
          inactive-color="#b2bfc3"
        >
        </el-switch>
      </div>
      <div class="m-o-btn" @click.stop="useAnalysisTemplate()">
        使用分析模板
      </div>
      <div class="m-o-btn" @click.stop="saveAsTemplate()">另存为模板</div>
      <div
        class="m-o-btn"
        :disabled="bmData.jsonData ? false : true"
        @click="openBindForm(bmData)"
      >
        绑定表单
      </div>
    </div>
    <div class="ma-main">
      <baseMessage
        :data="bmData.jsonData"
        :imageList="imageList.jsonData"
        :dataList="dataList"
        :tid="tid"
        @saveData="saveBaseData"
        @saveImage="saveBaseImage"
        @saveVideo="saveBaseVideo"
        @saveNephogram="saveBaseNephogram"
        @delImage="delBaseImageList"
				@getVideoAudioSuccess="getVideoAudioSuccess"
        v-loading="baseMessageLoading"
      />

      <analysis
        v-for="(item, index) in dialogTagList"
        :key="item.value"
        :index="index"
        :dialogTagList="dialogTagList"
        :maxIndex="dialogTagList.length - 1"
        @updateMessage="updateMessage"
        :ref="`analysis_${item.value}`"
        :showBrief="showBrief"
        @delItem="delAnalysisItem"
        @editItem="editAnalysisItem"
        @saveItem="saveAnalysis"
        @changeAnalysisName="changeAnalysisName"
        @addNewAnalysisGroup="addNewAnalysisGroup"
        @delAnalysisGroup="delAnalysisGroup"
        @setTheLocation="setTheLocation"
        @moveAnalysis="moveAnalysis"
        :dataList="dataList.filter(i => !(item.value == 0 && i.tIndex == 2))"
        :bmData="bmData.jsonData"
        :title="item.name"
        :dialogTagDataList="dialogTagDataList"
        :analysisItemList="
          dataList.filter(
            i => i.Type === item.value && (item.value != 0 || i.tIndex != 2)
          )
        "
        :type="item.value"
        :tid="tid"
        :fileId="fileId"
        :isDrag="isDrag"
        v-loading="item.loading"
      />
    </div>
    <!-- 添加模块 -->
    <addNewAnalysisDialog
      @update="getDialogTagDataList"
      :canAddNew="true"
      :dialogTagDataList="dialogTagDataList"
      ref="addNewAnalysisDialogRef"
      @success="addAnalysisItem"
    />
    <!-- 绑定 表单 -->
    <bindingFormDialog
      ref="bindingFormDialogRef"
      :tid="tid"
      @success="bindingForm"
    />
    <!-- 保存模板 -->
    <saveTemplateDialog
      ref="saveTemplateDialogRef"
      :bmData="bmData"
      :dataList="dataList"
    />
    <!-- 分析模板 -->
    <analysisTemplateDialog
      ref="analysisTemplateDialogRef"
      @useTemplate="useTemplate"
      :dataList="dialogTagDataList"
    />
  </div>
</template>

<script>
import baseMessage from "./baseMessage.vue"; //基本信息
// import currencyAnalysis from "./currencyAnalysis.vue"; //通用课堂分析
// import scienceAnalysis from "./scienceAnalysis.vue"; //科学课堂分析
// import extendAnalysis from "./extendAnalysis.vue"; //扩展分析
import analysis from "./analysis.vue";
import bindingFormDialog from "./bindingFormDialog.vue";
import saveTemplateDialog from "./saveTemplateDialog.vue";
import addNewAnalysisDialog from "./addNewAnalysisDialog.vue";
// 分析模板
import analysisTemplateDialog from "./analysisTemplateDialog.vue";

export default {
  emits: [
    "changeChatAreaAudioUrl",
    "changeTranscription",
    "changeOptionData",
    "updateTime"
  ],
  components: {
    baseMessage,
    // currencyAnalysis,
    // scienceAnalysis,
    // extendAnalysis,
    analysis,
    bindingFormDialog,
    saveTemplateDialog,
    analysisTemplateDialog,
    addNewAnalysisDialog
  },
  props: {
    tid: {
      type: String,
      default: ""
    },
    fileId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      showBrief: true, //是否显示模块简介
      // dialogVisible: false,
      // tagIndex: 0,
      // tagSubject: "",
      loading: false,
      baseMessageLoading: false,
      currencyLoading: false,
      scienceLoading: false,
      extendLoading: false,
      valueAddedLoading: false,
      userId: this.$route.query["userid"],
      // input2: "",
      dialogTagList: [
        { value: 0, name: "通用课堂分析", loading: false },
        { value: 1, name: "学科课堂分析", loading: false },
        { value: 2, name: "扩展分析", loading: false }
        //{ id: 3, name: "增值性分析" },
      ],
      dialogTagDataList: [],
      bmData: {},
      dataList: [],
      imageList: {},
      isDrag: false,
      copyDataList: []
    };
  },
  computed: {
    // searchDataList() {
    // 	let _result = this.dialogTagDataList.filter(
    // 		(i) => i.type == this.tagIndex
    // 	);
    // 	if (this.input2) {
    // 		_result = _result.filter((i) => i.name.indexOf(this.input2) > -1);
    // 	}
    // 	if (this.tagSubject) {
    // 		_result = _result.filter((i) => i.subject == this.tagSubject);
    // 	}
    // 	return _result;
    // },
    // tagSubjectList() {
    // 	let _result = [];
    // 	this.dialogTagDataList
    // 		.filter((i) => i.type == this.tagIndex)
    // 		.forEach((i) => {
    // 			if (i.subject && !_result.includes(i.subject)) {
    // 				_result.push(i.subject);
    // 			}
    // 		});
    // 	return _result;
    // },
  },
  watch: {
    isDrag(newValue) {
      if (newValue) {
        this.copyDataList = JSON.parse(JSON.stringify(this.dataList));
      }
    }
    // tagIndex() {
    // 	this.tagSubject = "";
    // },
  },
  methods: {
		getVideoAudioSuccess(file){
			this.$emit("getVideoAudioSuccess",file)
		},
    // 绑定表单
    bindingForm(obj) {
      this.bmData.jsonData.testData = obj;
      this.saveData(this.bmData).then(_ => {
        this.$message.success("绑定成功");
        this.$refs.bindingFormDialogRef.close();
      });
    },
    delAnalysisItem(id) {
      let _index = this.dataList.findIndex(i => i.id == id);
      if (_index > -1) {
        let _data = this.dataList[_index];
        let params = {
          id: _data.id,
          type: _data.Type,
          tid: this.tid
        };
        this.loading = true;
        this.ajax
          .post("https://gpt4.cocorobo.cn/delete_classroom_observation", params)
          .then(res => {
            this.dataList.splice(_index, 1);
            this.$message.success("删除成功");
            this.loading = false;
          })
          .catch(e => {
            this.$message.error("删除失败");
            this.loading = false;
          });
      } else {
        this.$message.error("删除失败");
        this.loading = false;
      }
    },
    editAnalysisItem(id, _data) {
      let _index = this.dataList.findIndex(i => i.id == id);
      if (_index != -1) {
        this.dataList[_index] = _data;
        // this.saveData(this.dataList[_index])
        this.$forceUpdate();
      } else {
        this.$message.info("执行错误");
      }
    },
    updateMessage(val) {
      this.$refs.addNewAnalysisDialogRef.open(val);
      // this.dialogVisible = true;
      // this.tagIndex = val;
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(_ => {
          done();
        })
        .catch(_ => {});
    },
    // 切换显示模板简介
    changeShowBrief(newValue) {
      this.showBrief = newValue;
    },
    // 使用分析模板
    useAnalysisTemplate() {
      // return;
      // if (!this.tid) return this.$message.error("请先选择课堂");
      this.$refs.analysisTemplateDialogRef.open();
    },
		checkUseTemplate(){
			return new Promise(resolve => {
				if(this.bmData && this.bmData.jsonData && this.bmData.jsonData.editorBarData){
					if(this.bmData.jsonData.editorBarData && (this.bmData.jsonData.editorBarData.content || this.bmData.jsonData.editorBarData.url)){
						this.$confirm("是否保留本课堂的转录文稿数据至新课堂?","提示").then(_ => {
							window.localStorage.setItem("saveEditorBarData",JSON.stringify({editorBarData:this.bmData.jsonData.editorBarData,fileId:this.fileId}));
							resolve(1);
						}).catch(_ => {
							resolve(2);
						})
					}else{
						resolve(2);
					}
				}else{
					resolve(2);
				}
			})
		},
    async useTemplate(json) {

			let saveStatus = await this.checkUseTemplate();
			// console.log("是否保留👉",saveStatus)
			// return;
      let _result = [];
      json.forEach(i => {
        if (i.isOtherData) return _result.push(i);
        let _obj = {
          jsonData: i.jsonData,
          type: i.Type,
          index: i.tIndex
        };
        _result.push(_obj);
      });
      // return console.log(_result);
      this.$parent
        .addNewCourseByTemplate(_result)
        .then(res => {
          this.$refs.analysisTemplateDialogRef.close();
          this.$refs.analysisTemplateDialogRef.loading = false;
        })
        .catch(e => {
          console.log(e);
          this.$refs.analysisTemplateDialogRef.loading = false;
        });
    },
    //另存为模板
    saveAsTemplate() {
      // return;
      if (!this.tid) return this.$message.error("请先选择课堂");
      this.$refs.saveTemplateDialogRef.open();
      // this.$message.info("另存为模板");
    },
    addAnalysisItem(name, id, type) {
      return new Promise((resolve, reject) => {
        var OpenCC = require("opencc-js");
        let converter = OpenCC.Converter({
          from: "hk",
          to: "cn"
        });
        this.$refs.addNewAnalysisDialogRef.close();
        // this.dialogVisible = false;
        let assistant = this.dialogTagDataList.find(i => i.id == id);

        // let parm = {
        // 	assistant_id: assistant ? assistant.agentid : null,
        // 	message:
        // 		"请使用代码解析器获取文件，帮我根据要求完整的分析，输出请按照要求。",
        // 	session_name: new Date().getTime(),
        // 	userId: this.userId,
        // 	file_ids: this.fileId,
        // };

        if (!assistant.agentid && !assistant.tips) {
          resolve();
          return this.$message.error("未找到对应的AI助手");
        }
        let newIndexData = this.dataList
          .filter(i => i.Type == type)
          .sort((a, b) => new Date(a.createtime) - new Date(b.createtime));
        newIndexData = newIndexData.length
          ? newIndexData[newIndexData.length - 1]
          : null;
        let newIndex = newIndexData
          ? newIndexData.tIndex + 1
          : type == 0
          ? 2
          : 0;
        let params = {
          index: newIndex,
          userid: this.userId,
          json_data: JSON.stringify({
            name: assistant.name,
            anotherName: assistant.name,
            mId: assistant.id,
            echartsType: assistant.echartsType,
            result: assistant.detail,
            fileList: [],
            dataFileList: [],
            content: ""
          }),
          tid: this.tid,
          type: type
        };

        // 这里调用添加
        this.ajax
          .post("https://gpt4.cocorobo.cn/insert_classroom_observation", params)
          .then(res => {
            let _data = res.data.FunctionResponse;
            if (
              _data.message &&
              converter(_data.message) == converter("创建成功")
            ) {
              let _result = JSON.parse(_data.result)[0];
              _result.jsonData = JSON.parse(_result.jsonData);
              this.dataList.push(_result);
              // if (_result.Type == 0) {
              //   this.$refs.analysis0[0].getReport(_result.id);
              // } else if (_result.Type == 1) {
              //   this.$refs.analysis1[0].getReport(_result.id);
              // } else if (_result.Type == 2) {
              //   this.$refs.analysis2[0].getReport(_result.id);
              // }
							this.$refs[`analysis_${_result.Type}`][0].getReport(_result.id);
              this.$message.success("添加成功");
              resolve();
            } else {
              this.$message.error("创建失败");
            }
          });
      });
    },
    // getCurrencyAndBaseMessageData() {
    //   if (!this.tid) return;
    //   return new Promise(resolve => {
    //     let pram = {
    //       tid: this.tid,
    //       // tid:'02',
    //       type: "0"
    //     };
    //     this.currencyLoading = true;
    //     this.dialogTagList.find(i => i.value == 0).loading = true;
    //     this.baseMessageLoading = true;
    //     this.bmData = {
    //       id: "",
    //       tId: this.tid,
    //       tIndex: 0,
    //       jsonData: {
    //         activity_methods: "",
    //         activity_structure: "",
    //         classroom_resources: "",
    //         courseName: "",
    //         name: "",
    //         studentNum: 0,
    //         subject: "",
    //         textbook: ""
    //       }
    //     };
    //     this.imageList = [];
    //     this.dataList = [];
    //     this.dialogTagList = [
    //       { value: 0, name: "通用课堂分析", loading: false },
    //       { value: 1, name: "学科课堂分析", loading: false },
    //       { value: 2, name: "扩展分析", loading: false }
    //     ];
    //     this.ajax
    //       .post("https://gpt4.cocorobo.cn/get_classroom_observation_new", pram)
    //       .then(res => {
    //         let _data = res.data.FunctionResponse.result.length
    //           ? JSON.parse(res.data.FunctionResponse.result)
    //           : [];
    //         if (_data.length == 0) {
    //           return this.insertBaseMessage().then(_ => {
    //             this.getCurrencyAndBaseMessageData();
    //           });
    //         }
    //         let _bmData = _data.find(i => i.tIndex == 0);
    //         let _dialogTagList = [];
    //         // 基础信息
    //         _bmData.jsonData = JSON.parse(_bmData.jsonData);
    //         _dialogTagList = _bmData.jsonData.dialogTagList || [
    //           { value: 0, name: "通用课堂分析", loading: false },
    //           { value: 1, name: "学科课堂分析", loading: false },
    //           { value: 2, name: "扩展分析", loading: false }
    //         ];
    //         // 图片
    //         let _imageList = _data.find(i => i.tIndex == 1);
    //         _imageList.jsonData = JSON.parse(_imageList.jsonData);

    //         if (!_imageList.jsonData.videoList) {
    //           _imageList.jsonData.videoList = [];
    //         }
    //         if (!_imageList.jsonData.NephogramList) {
    //           _imageList.jsonData.NephogramList = [];
    //         }
    //         //通用分析
    //         let currency = [];
    //         for (let i = 2; i < _data.length; i++) {
    //           let _currency = _data[i];
    //           _currency.jsonData = JSON.parse(_currency.jsonData);
    //           currency.push(_currency);
    //         }

    //         this.dataList.push(...currency);
    //         this.bmData = _bmData;
    //         this.dialogTagList = _dialogTagList;
    //         this.$emit("changeTranscription", {
    //           transcriptionData: this.bmData.jsonData.transcriptionData
    //             ? this.bmData.jsonData.transcriptionData
    //             : "",
    //           editorBarData: this.bmData.jsonData.editorBarData
    //             ? this.bmData.jsonData.editorBarData
    //             : { type: "0", content: "", url: "" }
    //         });
    //         this.imageList = _imageList;
    //         if (this.imageList.jsonData.fileList.length > 0) {
    //           this.$emit(
    //             "changeChatAreaAudioUrl",
    //             this.imageList.jsonData.fileList[0]
    //           );
    //         } else {
    //           this.$emit("changeChatAreaAudioUrl", { name: "", url: "" });
    //         }
    //         this.$emit("updateTime", this.bmData.createtime);
    //         this.baseMessageLoading = false;
    //         this.dialogTagList.find(i => i.value == 0).loading = false;
    //         this.currencyLoading = false;
    //         resolve();
    //       })
    //       .catch(e => {
    //         this.$message.error("获取通用分析失败");
    //         console.log(e);
    //         resolve();
    //       });
    //   });
    // },
    // getScienceData() {
    //   if (!this.tid) return;
    //   return new Promise(resolve => {
    //     let pram = {
    //       tid: this.tid,
    //       // tid:'02',
    //       type: "1"
    //     };
    //     this.scienceLoading = true;
    //     this.dialogTagList.find(i => i.value == 1).loading = true;
    //     this.ajax
    //       .post("https://gpt4.cocorobo.cn/get_classroom_observation_new", pram)
    //       .then(res => {
    //         let _data = res.data.FunctionResponse.result.length
    //           ? JSON.parse(res.data.FunctionResponse.result)
    //           : [];
    //         if (_data.length == 0) {
    //           this.dialogTagList.find(i => i.value == 1).loading = false;
    //           return (this.scienceLoading = false);
    //         }
    //         let science = [];
    //         for (let i = 0; i < _data.length; i++) {
    //           let _science = _data[i];
    //           _science.jsonData = JSON.parse(_science.jsonData);
    //           science.push(_science);
    //         }
    //         this.dataList.push(...science);
    //         this.dialogTagList.find(i => i.value == 1).loading = false;
    //         this.scienceLoading = false;
    //         resolve();
    //       })
    //       .catch(e => {
    //         this.$message.error("获取科学分析失败");
    //         resolve();
    //         console.log(e);
    //       });
    //   });
    // },
    // getExtendData() {
    //   if (!this.tid) return;
    //   return new Promise(resolve => {
    //     let pram = {
    //       tid: this.tid,
    //       // tid:'02',
    //       type: "2"
    //     };
    //     this.extendLoading = true;
    //     this.dialogTagList.find(i => i.value == 2).loading = true;
    //     this.ajax
    //       .post("https://gpt4.cocorobo.cn/get_classroom_observation_new", pram)
    //       .then(res => {
    //         let _data = res.data.FunctionResponse.result.length
    //           ? JSON.parse(res.data.FunctionResponse.result)
    //           : [];
    //         if (_data.length == 0) {
    //           this.dialogTagList.find(i => i.value == 2).loading = false;
    //           return (this.extendLoading = false);
    //         }
    //         let extent = [];
    //         for (let i = 0; i < _data.length; i++) {
    //           let _extent = _data[i];
    //           _extent.jsonData = JSON.parse(_extent.jsonData);
    //           extent.push(_extent);
    //         }
    //         this.dataList.push(...extent);
    //         this.dialogTagList.find(i => i.value == 2).loading = false;
    //         this.extendLoading = false;
    //         resolve();
    //       })
    //       .catch(e => {
    //         this.$message.error("获取扩展分析失败");
    //         console.log(e);
    //         resolve();
    //       });
    //   });
    // },
    getAnalysisData(type) {
      if (!this.tid) return;
      let _copyTid = this.tid;
      return new Promise(resolve => {
        let params = {
          tid: this.tid,
          type: type
        };

        this.dialogTagList.find(i => i.value == type)
          ? (this.dialogTagList.find(i => i.value == type).loading = true)
          : "";
        if (type == 0) {
          this.baseMessageLoading = true;
          this.bmData = {
            id: "",
            tId: this.tid,
            tIndex: 0,
            jsonData: {
              activity_methods: "",
              activity_structure: "",
              classroom_resources: "",
              courseName: "",
              name: "",
              studentNum: 0,
              subject: "",
              textbook: ""
            }
          };
          this.imageList = [];
          this.dataList = [];
          this.dialogTagList = [
            { value: 0, name: "通用课堂分析", loading: true },
            { value: 1, name: "学科课堂分析", loading: true },
            { value: 2, name: "扩展分析", loading: true }
          ];
        }

        this.ajax
          .post(
            "https://gpt4.cocorobo.cn/get_classroom_observation_new",
            params
          )
          .then(res => {
            if (_copyTid != this.tid) return;
            let _data = res.data.FunctionResponse.result.length
              ? JSON.parse(res.data.FunctionResponse.result)
              : [];

            if (_data.length == 0) {
              return (this.dialogTagList.find(
                i => i.value == type
              ).loading = false);
            }

            if (type == 0) {
              //第一个分析
              let _bmData = _data.find(i => i.tIndex == 0);
              let _dialogTagList = [];
              // 基础信息
              _bmData.jsonData = JSON.parse(_bmData.jsonData);
              _dialogTagList = _bmData.jsonData.dialogTagList || [
                { value: 0, name: "通用课堂分析", loading: false },
                { value: 1, name: "学科课堂分析", loading: false },
                { value: 2, name: "扩展分析", loading: false }
              ];
              // 图片
              let _imageList = _data.find(i => i.tIndex == 1);
              _imageList.jsonData = JSON.parse(_imageList.jsonData);

              if (!_imageList.jsonData.videoList) {
                _imageList.jsonData.videoList = [];
              }
              if (!_imageList.jsonData.NephogramList) {
                _imageList.jsonData.NephogramList = [];
              }
              //通用分析
              let currency = [];
              for (let i = 2; i < _data.length; i++) {
                let _currency = _data[i];
                _currency.jsonData = JSON.parse(_currency.jsonData);
                currency.push(_currency);
              }

							//判断是否有保留装了文稿数据
							let saveEditorBarData = window.localStorage.getItem("saveEditorBarData")?JSON.parse(window.localStorage.getItem("saveEditorBarData")):null;
							if(saveEditorBarData){
								console.log("saveEditorBarData👉",saveEditorBarData)
								_bmData.jsonData.editorBarData = saveEditorBarData.editorBarData;
								// this.fileId = _saveEditorBarData.fileId;
								window.localStorage.removeItem("saveEditorBarData");
							}
              this.dataList.push(...currency);
              this.bmData = _bmData;
              this.dialogTagList = _dialogTagList;
              this.$emit("changeTranscription", {
                transcriptionData: this.bmData.jsonData.transcriptionData
                  ? this.bmData.jsonData.transcriptionData
                  : "",
                editorBarData: this.bmData.jsonData.editorBarData
                  ? this.bmData.jsonData.editorBarData
                  : { type: "0", content: "", url: "" }
              });
              this.imageList = _imageList;
              if (this.imageList.jsonData.fileList.length > 0) {
                this.$emit(
                  "changeChatAreaAudioUrl",
                  this.imageList.jsonData.fileList[0]
                );
              } else {
                this.$emit("changeChatAreaAudioUrl", { name: "", url: "" });
              }
              this.$emit("updateTime", this.bmData.createtime);
              this.baseMessageLoading = false;
              this.dialogTagList.find(i => i.value == type)
                ? (this.dialogTagList.find(
                    i => i.value == type
                  ).loading = false)
                : "";

							if(saveEditorBarData){
								console.log("保存数据👉",saveEditorBarData)
								this.$parent.updateFileId(saveEditorBarData.fileId);
								this.saveData(this.bmData);
							}
              resolve();
            } else {
              if (_data.length == 0) {
                return (this.dialogTagList.find(
                  i => i.value == type
                ).loading = false);
              }
              let _analysisData = [];
              for (let i = 0; i < _data.length; i++) {
                let _analysis = _data[i];
                _analysis.jsonData = JSON.parse(_analysis.jsonData);
                _analysisData.push(_analysis);
              }
              this.dataList.push(..._analysisData);
              this.dialogTagList.find(i => i.value == type).loading = false;
              resolve();
            }
          })
          .catch(e => {
            console.log(e);
            this.$message.error("获取分析失败");
            resolve();
          });
      });
    },
    // getValueAddedData() {
    //   if (!this.tid) return;
    //   let pram = {
    //     tid: this.tid,
    //     // tid:'02',
    //     type: "3"
    //   };
    //   this.valueAddedLoading = true;
    //   this.ajax
    //     .post("https://gpt4.cocorobo.cn/get_classroom_observation_new", pram)
    //     .then(res => {
    //       let _data = res.data.FunctionResponse.result.length
    //         ? JSON.parse(res.data.FunctionResponse.result)
    //         : [];
    //       if (_data.length == 0) {
    //         return (this.valueAddedLoading = false);
    //       }
    //       let valueAdded = [];
    //       for (let i = 0; i < _data.length; i++) {
    //         let _valueAdded = _data[i];
    //         _valueAdded.jsonData = JSON.parse(_valueAdded.jsonData);
    //         valueAdded.push(_valueAdded);
    //       }
    //       this.dataList.push(...valueAdded);
    //       this.valueAddedLoading = false;
    //     })
    //     .catch(e => {
    //       this.$message.error("获取增值性分析失败");
    //       console.log(e);
    //     });
    // },
    saveAnalysis(id, _data) {
      let data = this.dataList.find(i => i.id == id);
      if (data) {
        this.saveData(data).then(() => {
          // this.$message.success("保存成功");
        });
      }
    },
    getData(arr = []) {
      return new Promise(resolve => {
        this.dataList = [];
        this.isDrag = false;
        this.$forceUpdate();
        if (this.tid) {
          return this.getAnalysisData(0).then(res => {
            this.$nextTick(() => {
              let promises = [];
              this.$nextTick(() => {
                let forData = arr.length ? arr : this.dialogTagList;
                this.dialogTagList = forData;
                forData.forEach(i => {
                  if (i.value === 0) return;
                  promises.push(this.getAnalysisData(i.value));
                });
                Promise.all(promises).then(res => {
                  this.dataList.sort((a, b) => a.tIndex - b.tIndex);
                  this.dataList.sort((a, b) => a.Type - b.Type);
                  resolve();
                });
              });
            });
          });
          // Promise.all([
          //   this.getCurrencyAndBaseMessageData(),
          //   this.getScienceData(),
          //   this.getExtendData()
          // ]).then(res => {
          //   resolve();
          // });
        } else {
          this.getDefaultData();
        }
      });
      // this.getValueAddedData();
      // this.getFileId();
    },
    getDefaultData() {
      if (this.tid) return;
      return new Promise(resolve => {
        let params = {
          uid: this.userId
        };
        this.loading = true;
        this.ajax
          .get(this.$store.state.api + "selectClassroomDefault", params)
          .then(res => {
            let _data = res.data[0][0];
            if (_data) {
              _data.tips = JSON.parse(_data.tips);
              _data.tips.forEach(i => {
                // if (i.jsonData.eChartData) {
                //   delete i.jsonData.eChartData;
                // }
                // if (i.jsonData.RT && i.jsonData.CH) {
                //   delete i.jsonData.RT;
                //   delete i.jsonData.CH;
                // }
              });
              this.dataList = _data.tips;
            }
            this.loading = false;
            resolve();
          });
      });
    },
    saveData(data) {
      return new Promise((resolve, reject) => {
        this.ajax
          .post("https://gpt4.cocorobo.cn/update_classroom_observation", {
            id: data.id,
            json_data: JSON.stringify(data.jsonData)
          })
          .then(res => {
            resolve();
          })
          .catch(e => {
            this.$message.error("保存失败");
            resolve();
          });
      });
      // return;
      // let saveDataList = [];

      // // 保存基础信息
      // saveDataList.push({
      // 	id: this.bmData.id,
      // 	json_data: JSON.stringify(this.bmData.jsonData),
      // });

      // // 所有分析
      // this.dataList.forEach((i1) => {
      // 	i1.forEach((i2) => {
      // 		saveDataList.push({
      // 			id: i2.id,
      // 			json_data: JSON.stringify(i2.jsonData),
      // 		});
      // 	});
      // });
      // let promises = [];
      // saveDataList.forEach((i) => {
      // 	promises.push(
      // 		new Promise((resolve) => {
      // 			let pram = {
      // 				id: i.id,
      // 				json_data: i.json_data,
      // 			};
      // 			this.ajax
      // 				.post(
      // 					"https://gpt4.cocorobo.cn/update_classroom_observation",
      // 					pram
      // 				)
      // 				.then((res) => {
      // 					console.log(res);
      // 					resolve();
      // 				});
      // 		})
      // 	);
      // });

      // Promise.all(promises).then((res) => {
      // 	this.$message.success("保存成功");
      // 	fn ? fn() : "";
      // });
    },
    saveBaseData() {
      this.bmData.json_data = JSON.stringify(this.bmData.jsonData);
      this.saveData(this.bmData).then(res => {
        this.$emit("changeOptionData", this.tid, {
          label: this.bmData.jsonData.courseName
        });
        this.$forceUpdate();
      });
    },
    saveBaseImage(newImage) {
      if (this.imageList.jsonData.fileList1.length == 0) {
        this.imageList.jsonData.fileList1.push(newImage);
      } else if (this.imageList.jsonData.fileList2.length == 0) {
        this.imageList.jsonData.fileList2.push(newImage);
      } else if (this.imageList.jsonData.fileList3.length == 0) {
        this.imageList.jsonData.fileList3.push(newImage);
      } else {
        this.$message.error("最多只能上传3张图片");
        return;
      }
      this.imageList.json_data = JSON.stringify(this.imageList.jsonData);
      this.saveData(this.imageList);
      this.$forceUpdate();
    },
    saveBaseVideo(newVideo) {
      if (
        (this.imageList.jsonData.videoList &&
          this.imageList.jsonData.videoList.length == 0) ||
        !this.imageList.jsonData.videoList
      ) {
        this.imageList.jsonData.videoList = [];
        this.imageList.jsonData.videoList.push(newVideo);
      } else {
        this.$message.error("最多只能上传1个视频");
        return;
      }
      this.imageList.json_data = JSON.stringify(this.imageList.jsonData);
      this.saveData(this.imageList);
    },
    saveBaseNephogram(newValue) {
      if (
        (this.imageList.jsonData.NephogramList &&
          this.imageList.jsonData.NephogramList.length == 0) ||
        !this.imageList.jsonData.NephogramList
      ) {
        this.imageList.jsonData.NephogramList = [];
        this.imageList.jsonData.NephogramList.push(newValue);
      } else {
        return;
      }
      this.imageList.json_data = JSON.stringify(this.imageList.jsonData);
      this.saveData(this.imageList);
    },
    delBaseImageList(key) {
      this.imageList.jsonData[key] = [];
      this.$forceUpdate();
      this.imageList.json_data = JSON.stringify(this.imageList.jsonData);
      this.saveData(this.imageList).then(res => {
        this.$message.success("删除成功");
        this.$forceUpdate();
      });
    },
    // 保存词频词汇分析
    saveWordFrequency({ _sentence = 0, _words = 0 }) {
      var OpenCC = require("opencc-js");
      let converter = OpenCC.Converter({
        from: "hk",
        to: "cn"
      });
      let _saveData = this.dataList.find(
        i => converter(i.jsonData.name) == converter("词频词汇分析")
      );
      if (_saveData) {
        _saveData.jsonData.wordCountNum = _sentence;
        _saveData.jsonData.wordNum = _words;
        this.saveData(_saveData).then(_ => {
          console.log("词频词汇分析");
        });
      }
    },
    // 切换录音文件
    changeAudioUrl(data) {
      this.imageList.jsonData.fileList = [];
      let audio = {
        name: data.key,
        status: "success",
        uid: "1",
        url: data.Location
      };
      this.imageList.jsonData.fileList.push(audio);
      this.saveData(this.imageList).then(res => {
        this.$message.success("更换录文件成功");
        this.$emit("changeChatAreaAudioUrl", audio);
      });
    },
    getReport() {
      var OpenCC = require("opencc-js");
      let converter = OpenCC.Converter({
        from: "hk",
        to: "cn"
      });
      let _empty = this.dataList.filter(
        i =>
          i.jsonData.content != "" && converter(i.jsonData.name) != converter("词频词汇分析")
      );

      // return console.log(_empty)
      console.log(_empty);
      if (_empty.length > 0) {
        this.$confirm("操作将覆盖原有内容，是否继续？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            this.dialogTagList.forEach(i => {
							console.log(this.$refs[`analysis_${i.value}`][0])
              this.$refs[`analysis_${i.value}`][0].getReport();
            });
            // this.$refs["analysis0"][0].getReport();
            // this.$refs["analysis1"][0].getReport();
            // this.$refs["analysis2"][0].getReport();
            this.$message.success("一键分析成功");
            // this.$refs.analysis3.getReport();
          })
          .catch(e => {
            console.log(e);
            console.log("取消生成报告");
          });
      } else {
				this.dialogTagList.forEach(i => {
					console.log(this.$refs[`analysis_${i.value}`][0])
          this.$refs[`analysis_${i.value}`][0].getReport();
        });
        this.$message.success("一键分析成功");
      }
    },
    insertBaseMessage() {
      return new Promise((resolve, reject) => {
        var OpenCC = require("opencc-js");
        let converter = OpenCC.Converter({
          from: "hk",
          to: "cn"
        });
        // 添加基础信息
        let params = {
          index: "0",
          json_data: JSON.stringify({
            courseName: "",
            studentNum: "0",
            subject: "",
            textbook: "",
            classroom_resources: "",
            activity_structure: "",
            activity_methods: "",
            name: ""
          }),
          tid: this.tid,
          type: "0"
        };
        // 添加课堂图片
        let params2 = {
          index: "1",
          tid: this.tid,
          type: "0",
          json_data: JSON.stringify({
            fileList: [],
            name: "课堂记录",
            fileList1: [],
            fileList2: [],
            fileList3: [],
            videoList: []
          })
        };
        this.ajax
          .post("https://gpt4.cocorobo.cn/insert_classroom_observation", params)
          .then(res => {
            let _data = res.data.FunctionResponse;
            if (
              _data.message &&
              converter(_data.message) == converter("创建成功")
            ) {
              this.ajax
                .post(
                  "https://gpt4.cocorobo.cn/insert_classroom_observation",
                  params2
                )
                .then(res2 => {
                  let _data2 = res2.data.FunctionResponse;
                  if (
                    _data2.message &&
                    converter(_data2.message) == converter("创建成功")
                  ) {
                  } else {
                    this.$message.error("创建课堂图片失败");
                  }
                  resolve();
                });
            } else {
              this.$message.error("创建基础信息失败");
            }
          });
      });
    },
    // 修改基本信息的原文速览和转录文稿
    updateMessageTranscription({ transcriptionData, editorBarData }, fn) {
      this.bmData.jsonData["transcriptionData"] = transcriptionData;
      this.bmData.jsonData["editorBarData"] = editorBarData;
      this.saveData(this.bmData).then(res => {
        this.$message.success("保存成功");
        fn ? fn() : "";
      });
    },
    openBindForm(_data) {
      if (!this.tid) return this.$message.error("请新建课堂，或选择历史课堂");
      this.$refs.bindingFormDialogRef.open(_data.jsonData);
    },
    getDialogTagDataList() {
      console.log("获取模块分析列表");
      let params = {
        uid: this.userId
      };
      this.ajax
        .get(this.$store.state.api + "select_smodel", params)
        .then(res => {
          let _result = res.data[0];
          this.dialogTagDataList = _result;
          // console.log(_result)
          this.$forceUpdate();
        })
        .catch(e => {
          this.$message.error("获取模块分析列表失败");
        });
    },
    changeAnalysisName(data, type = 0) {
      if (type == 0) {
        this.dialogTagList.find(i => i.value == data.type).name = data.name;
      } else if (type == 1) {
        this.dialogTagList = data;
      }
      this.bmData.jsonData["dialogTagList"] = this.dialogTagList;
      this.saveData(this.bmData).then(res => {
        // this.$message.success("修改名称成功");
      });
    },
    addNewAnalysisGroup(data) {
      let _index = this.dialogTagList.findIndex(i => i.value === data.type);
      let _maxValue = Math.max(...this.dialogTagList.map(i => i.value)) + 1;
      if ([10, 11].includes(_maxValue)) {
        _maxValue = 12;
      }
      let newData = { value: _maxValue, name: "新建的分析", loading: true };
      if (data.po == 0) {
        this.dialogTagList.splice(_index, 0, newData);
      } else if (data.po == 1) {
        this.dialogTagList.splice(_index + 1, 0, newData);
      }
      this.saveData(this.bmData).then(res => {
        this.getAnalysisData(newData.value);
        this.$message.success("添加分析分组成功");
      });
    },
    delAnalysisGroup(data) {
      let _index = this.dialogTagList.findIndex(i => i.value === data.type);
      this.dialogTagList[_index].loading = true;
      let promises = [];
      data.groupId.forEach(i => {
        promises.push(this.delAnalysisItem2(i));
      });

      if (promises.length > 0) {
        return Promise.all(promises).then(res => {
          this.dialogTagList.splice(_index, 1);
          this.$message.success("删除分析分组成功");
          this.dataList = this.dataList.filter(i=>!data.groupId.includes(i.id))
          this.bmData.jsonData.dialogTagList = this.dialogTagList;
          this.saveData(this.bmData);
        });
      } else {
        this.dialogTagList.splice(_index, 1);
        this.$message.success("删除分析分组成功");
        this.bmData.jsonData.dialogTagList = this.dialogTagList;
        return this.saveData(this.bmData);
      }
    },
    delAnalysisItem2(id) {
      return new Promise(resolve => {
        let delData = this.dataList.find(i => i.id === id);
        if (delData) {
          let params = {
            id: delData.id,
            type: delData.Type,
            tid: this.tid
          };
          this.ajax
            .post(
              "https://gpt4.cocorobo.cn/delete_classroom_observation",
              params
            )
            .then(res => {
              // this.dataList.splice(_index, 1);
              resolve();
            })
            .catch(e => {
              console.log(e);
              resolve();
            });
        } else {
          resolve();
        }
      });
    },
    setTheLocation(data) {
      let moveList = JSON.parse(JSON.stringify(this.dialogTagList));
      let _index = moveList.findIndex(i => i.value === data.value);
      if (_index === -1) return; // 如果没找到，直接退出
      if (data.type == 0) {
        // 置顶
        moveList = this.moveListFn(moveList, _index, 0);
      } else if (data.type == 1) {
        // 置底
        moveList = this.moveListFn(moveList, _index, moveList.length - 1);
      } else if (data.type == 2) {
        // 上移
        moveList = this.moveListFn(moveList, _index, _index - 1);
      } else if (data.type == 3) {
        // 下移
        moveList = this.moveListFn(moveList, _index, _index + 1);
      }
      this.dialogTagList = moveList;
      this.bmData.jsonData["dialogTagList"] = this.dialogTagList;
      this.saveData(this.bmData);
      this.$forceUpdate();
    },
    moveListFn(arr, fromIndex, toIndex) {
      // 确保索引在数组范围内
      if (
        fromIndex >= 0 &&
        fromIndex < arr.length &&
        toIndex >= 0 &&
        toIndex < arr.length
      ) {
        // 删除要移动的元素并存储
        const element = arr.splice(fromIndex, 1)[0];
        // 在新的位置插入元素
        arr.splice(toIndex, 0, element);
      }
      return arr;
    },
    moveArrayElement(arr, fromIndex, toIndex) {
      const element = arr[fromIndex];
      arr.splice(fromIndex, 1); // 删除原位置的元素

      // 调整目标下标以确保正确插入
      const newIndex = toIndex < fromIndex ? toIndex : toIndex - 1;

      arr.splice(newIndex, 0, element); // 插入到新位置
      return arr;
    },
    moveAnalysis(data) {
      let _form = data.form.split("_");
      let _to = data.to.split("_");

      if (_form[0] === _to[0] && _form[1] === _to[1] && _form[2] === _to[2])
        return console.log("位置不变");
      if (
        _form[0] === _to[0] &&
        parseInt(_form[1]) - 1 === parseInt(_to[1]) &&
        _to[3] == "1"
      )
        return console.log("位置不变2");
      let _formIndex = this.dataList.findIndex(
        i => i.Type == parseInt(_form[0]) && i.tIndex == parseInt(_form[2])
      );
      let _toIndex = -1;
      if (["0", "1"].includes(_to[3])) {
        _toIndex = this.dataList.findIndex(
          i => i.Type == parseInt(_to[0]) && i.tIndex == parseInt(_to[2])
        );
      }
      // 更新Type与tIndex
      this.dataList[_formIndex].Type = parseInt(_to[0]);
      if (_to[3] === "1") {
        //下面
        this.moveArrayElement(this.dataList, _formIndex, _toIndex+1);
      } else if (_to[3] === "0") {
        //上面
        this.moveArrayElement(this.dataList, _formIndex, _toIndex);
      } else if (_to[3] === "2") {
        console.log("移到了空模块");
      }

      this.dialogTagList.forEach(i => {
        let _data = this.dataList.filter(i2 => i2.Type === i.value);
        let _fTIndex = i.value === 0 ? 2 : 0;
        _data.forEach(i3 => {
          if (this.dataList.find(i4 => i4.id === i3.id).tIndex != _fTIndex) {
            this.dataList.find(i4 => i4.id === i3.id).tIndex = _fTIndex;
          }
          _fTIndex++;
        });
      });
      this.$forceUpdate();
      console.log("更换成功");
    },
    moveAnalysisCancel() {
      this.isDrag = false;
      this.dataList = JSON.parse(JSON.stringify(this.copyDataList));
      this.copyDataList = [];
    },
		moveAnalysisSubmit(){
			this.loading = true;
			if(JSON.stringify(this.copyDataList)===JSON.stringify(this.dataList)){
				this.isDrag = false;
				this.loading = false;
				// this.$message.success("更换成功")
				return
			}

			let _copyData = JSON.parse(JSON.stringify(this.dataList));

			_copyData = _copyData.filter(i=>!(i.Type==0&&i.tIndex==2));

			let _result = _copyData.map(i=>({id:i.id,tIndex:i.tIndex,Type:i.Type}));

			let params = {
				data:JSON.stringify(_result)
			}
			this.ajax.post('https://gpt4.cocorobo.cn/batch_update_type_tindex',params).then(res=>{
				this.isDrag = false;
				this.loading = false;
				this.$message.success("保存成功")
			}).catch(e=>{
				console.log(e)
				this.isDrag = true;
				this.loading = false;
				this.$message.error("保存失败")
			})
		},
    init() {
      this.bmData = {};
      this.getDefaultData();
      this.imageList = {};
      this.loading = false;
      this.baseMessageLoading = false;
      this.currencyLoading = false;
      // this.dialogTagList.find(i => i.value == 0).loading = false;
      // this.dialogTagList.find(i => i.value == 1).loading = false;
      // this.dialogTagList.find(i => i.value == 2).loading = false;
      this.scienceLoading = false;
      this.extendLoading = false;
      this.valueAddedLoading = false;
    }
  },
  mounted() {
    this.getDialogTagDataList();
  }
};
</script>

<style scoped>
.messageArea {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 20px 10px;
}
.m-operation {
  width: 100%;
  height: 30px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  font-size: 14px;
  box-sizing: border-box;
  padding-right: 30px;
  margin-bottom: 10px;
}
.m-o-btn {
  width: auto;
  height: 33px;
  padding: 0 12px;
  background-color: #ffffff;
  box-sizing: border-box;
  border: solid 1px #bdbdbd;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
  border-radius: 17px;
  cursor: pointer;
}
.m-o-switch {
  display: flex;
  align-items: center;
  margin-right: 10px;
}
.m-o-s-text {
  margin-right: 4px;
  cursor: pointer;
}
.ma-main {
  width: 100%;
  height: calc(100vh - 123px);
  overflow: auto;
  position: relative;
}

.a-d-top {
  /* background: #adadad; */
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  height: 54px;
  border-radius: 8px 8px 0 0;
  user-select: none;
  border-bottom: 1px #ccc solid;
}
.a-d-top >>> .el-input__inner {
  width: 320px;
  height: 32px;
}
.a-d-top >>> .el-input__icon {
  line-height: 32px;
}
.a-d-topTit {
  width: 171px;
  height: 32px;
  display: flex;
  align-items: center;
  font-family: PingFang SC;
  box-sizing: border-box;
  padding: 5px;
  line-height: 22px;
  justify-content: center;
  /* text-align: left; */
}
.a-d-t-left {
  width: 200px;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: flex-start;
  box-sizing: border-box;
  padding-left: 5px;
}

.a-d-t-l-item {
  /* width: auto;
	height: 90%;
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 0 10px;
	border-radius: 10px;
	background-color: #d4d9da;
	margin-right: 3px;
	cursor: pointer; */
  cursor: pointer;
  width: 136px;
  height: 32px;
  display: flex;
  align-items: center;
  border-radius: 5px;
  font-family: PingFang SC;
  box-sizing: border-box;
  padding: 5px;
  font-size: 14px;
  font-weight: 600;
  line-height: 22px;
  text-align: left;
  margin-top: 20px;
  /* margin-bottom: 20px; */
}

.a-d-t-l-item:hover {
  background-color: white;
}

.a-d-t-right {
  width: 40px;
  height: 40px;
  margin-right: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: black !important;
}

.a-d-t-right > span {
  width: 25px;
  height: 25px;
  border-radius: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  /* align-items: center; */
  font-size: 22px;
  color: #fff;
  /* background-color: #adadad; */
  cursor: pointer;
  /* background-color: #e6e6e6; */
  color: #adadad;
}

.a-d-box {
  width: 100%;
  height: 100%;
  background-color: #f0f2f5;
  overflow: scroll;
  overflow-x: hidden;
  box-sizing: border-box;
  padding: 15px;
  padding-bottom: 50px;
}

.a-d-b-item {
  width: 22%;
  height: 200px;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 10px;
  padding: 15px;
  float: left;
  box-sizing: border-box;
  margin-bottom: 10px;
  margin-right: 20px;
  transform: 0.3s;
  box-shadow: 0 16px 24px 2px #f0f2f5;
  /* position: relative; */
}

.a-d-b-item:hover {
  box-shadow: 0 16px 24px 2px #0000001c;
}

.a-d-b-item:hover .a-d-b-i-bottomBtn {
  display: block !important;
}
.a-d-b-item:hover .a-d-b-i-bottomPer {
  display: none !important;
}
.a-d-b-i-top {
  width: 100%;
  /* height: 50%; */
  height: 20px;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  /* justify-content: space-between; */
}
.a-d-b-i-top > img {
  width: 35px;
  height: 35px;
}
/* .a-d-b-i-top>div{ */
/* width: auto;
	height: 35px;
	display: flex;
	justify-content: center;
	align-items: center;
	margin-left: 10px; */
/* } */

.a-d-b-i-t-title {
  width: 100%;
  height: 35px;
  display: block;
  align-items: center;
  box-sizing: border-box;
  padding: 0 10px;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  white-space: nowrap;
  line-height: 35px;
  /* display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 1;
	overflow: hidden; */
}

.a-d-b-i-bottom {
  width: 100%;
  flex: 1;
  overflow: hidden;
  /* max-height: 186px; */
  font-size: 14px;
  -webkit-line-clamp: 5;
  line-height: 20px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.a-d-b-i-t-btn {
  font-size: 14px;
  box-sizing: border-box;
  padding: 8px 25px;
  border: 1px solid rgba(54, 129, 252, 1);
  border-radius: 5px;
  color: rgba(54, 129, 252, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.a-d-b-i-t-btn1 {
  font-size: 14px;
  width: 98%;
  box-sizing: border-box;
  padding: 8px 25px;
  border: 1px solid rgba(54, 129, 252, 1);
  border-radius: 5px;
  background-color: rgba(54, 129, 252, 1);
  display: flex;
  color: #fff;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.addTemplateDialog >>> .el-dialog {
  min-width: 1200px;

  height: 700px;
  box-shadow: 0px 0 8px 0px #555555;
  border-radius: 8px;
  background-color: #fff;
  /* top: 0px; */
  /* margin: 0 auto; */
  overflow: hidden;
}
.addTemplateDialog >>> .el-dialog__body {
  height: 100%;
  min-width: 1200px;
  flex-shrink: 0;
  box-sizing: border-box;
  padding-bottom: 50px;
  padding-top: 10px;
}
.addTemplateDialog >>> .el-dialog__header {
  display: none;
}
.itemTit {
  width: 136px;
  height: 32px;
  padding: 5px 8px 5px 8px;
  gap: 8px;
  opacity: 0px;
  margin: 20px 0;
  margin-bottom: 10px;
  border-bottom: 1px #ccc solid;
}

.a-d-b-subject {
  margin: 20px 0 20px 0;
}

.a_d_b_s_btn {
  /* box-sizing: border-box; */
  padding: 5px 10px;
  border-radius: 4px;
  border: solid 1px #3681fc;
  color: #3681fc;
  background-color: white;
  margin-right: 10px;
  cursor: pointer;
  transition: 0.3s;
}

.a_d_b_s_ActiveBtn {
  background-color: #3681fc;
  color: white;
}

.a-d-b-i-t-btn:hover {
  background-color: rgba(54, 129, 252, 1);
  color: #fff;
}

/* .ma_m_addNewAnalysisBox{
	width: calc(100% - 10px);
	height: 60px;
	background-color: red;
	border-radius: 8px;
	margin: 10px 0px 20px 0;
} */
</style>



// WEBPACK FOOTER //
// src/components/pages/classroomObservation/components/messageArea.vue